module.exports = __webpack_public_path__ + "static/media/Billboard.5f5dfa1e.png";